module.exports = __webpack_public_path__ + "static/media/19ESCAP51.f7159c05.jpg";